import Vue from 'vue'
import App from './App.vue'
import routerConfig from 'js/config/router-config';
import './css/common.css'
import 'mint-ui/lib/style.css'
Vue.config.productionTip = false
const router = routerConfig();

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
